import React from 'react';
import { createPortal } from 'react-dom';
import { Tooltip, Paper, Box } from '@mui/material';
import { useMap, useMapEvents } from 'react-leaflet';
import { useDispatch, useSelector } from 'react-redux';
import { Badge } from '@mui/material';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import CircularProgress, { circularProgressClasses } from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useState, useEffect, useMemo, useRef } from 'react';
import LayersIcon from '@mui/icons-material/Layers';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import { Filter, FilterAlt } from '@mui/icons-material';
import { setModal } from '../../../store/reducers/helpersReducer';
import L from 'leaflet';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { selectAccountingsFiltered, selectAccountingsFilteredCounts, selectAccountingsFilteredCountsNew } from '../../../store/selectors/supervisionSelector';





const AccountingSheetTableButton = () => {
    const dispatch = useDispatch()
    const [isOpen, setIsOpen] = useState(false)
    const buttonRef = useRef(null);
    const filter = useSelector(state => state.state.filter)
    const accountingsCounts = useSelector(selectAccountingsFilteredCountsNew)
    const [count, setCount] = useState({
        active: 0,
        not_completed: 0,
        half_completed: 0,
        ready: 0
    })
    const buttonPosition = useMemo(() => {
        const buttonRect = buttonRef.current?.getBoundingClientRect();
        return buttonRect ? {
            top: buttonRect.top,
            left: buttonRect.left,
            right: buttonRect.right,
            bottom: buttonRect.bottom,
            width: buttonRect.width,
            height: buttonRect.height
        } : null;
    }, [buttonRef.current]);

    // Add effect to listen for modal close events
    useMapEvents({
        'modal:open': (e) => {
            if (e.modalType !== 'accountingSheetTable') {
                setIsOpen(false)
            }
        },
        'modal:close': () => {
            setIsOpen(false)
        }
    })

    useEffect(() => {
        if (buttonRef.current) {
            L.DomEvent.disableClickPropagation(buttonRef.current)
            L.DomEvent.disableScrollPropagation(buttonRef.current)
        }
    }, [buttonRef.current])

    const handleOpenToggle = (newState) => {
        setIsOpen(newState)
        if (newState) {
            dispatch(setModal({ modalType: 'accountingSheetTable', modalProps: { buttonPosition } }))
        } else {
            dispatch(setModal(null))
        }
    }

    // useEffect(() => {
    //     if (isOpen) {
    //         dispatch(setModal({modalType: 'accountingSheetTable', modalProps: { buttonPosition }}))
    //         // map.fire('modal:open', { modalType: 'accountingSheetTable', modalProps: { buttonPosition } })
    //     } else {
    //         dispatch(setModal(null))
    //         // map.fire('modal:close'   )
    //     }
    // }, [isOpen])


    // useEffect(() => {
    //     const tofilter = ['Не устранено', 'Частично устранено']
    //     const tpFilter = filter.tp
    //     const dateFilter = filter.date
    //     if (accountingNewObjectFiltered) {
    //         let accounting = tpFilter ? accountingNewObjectFiltered.filter(ano => !tpFilter.find(f => f === ano.tp.fid)) : accountingNewObjectFiltered
    //         accounting = dateFilter ? accounting.map(ano => {
    //             return {
    //                 ...ano,
    //                 pillars: ano.pillars.filter(h => new Date(h.date) >= new Date(dateFilter.start) && new Date(h.date) <= new Date(dateFilter.end))
    //             }
    //         }) : accounting
    //         setCount((p) => ({
    //             ...p,
    //             active: accounting.reduce((t, r) => t + r.pillars.filter(pillar => tofilter.includes(pillar.accounting.status)).length, 0),
    //             not_completed: accounting.reduce((t, r) => t + r.pillars.filter(pillar => pillar.accounting.status === 'Не устранено').length, 0),
    //             half_completed: accounting.reduce((t, r) => t + r.pillars.filter(pillar => pillar.accounting.status === 'Частично устранено').length, 0),
    //             // active: 0,
    //             // ready: accountingNewObject.reduce((t, r) => t + r.pillars.filter(pillar => pillar.accounting.status === 'Частично устранено').length, 0)
    //             ready: accounting.reduce((t, r) => t + r.pillars.filter(pillar => pillar.accounting.status === 'Готово к проверке').length, 0),

    //         }))
    //         // setAccounting(accounting)
    //     }
    // }, [accountingNewObjectFiltered, filter])





    return createPortal(
        <Box sx={{ zIndex: 1202, display: 'flex', order: 3, pointerEvents: 'auto', width: 'fit-content' }}>
            <Tooltip title='Предписания авторского надзора ООО "КОМОКС"' placement='right' arrow>
                <Paper
                    elevation={3}
                    id='accounting-table-button'
                    ref={buttonRef}
                    sx={{
                        display: 'flex',
                        order: 3,
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: window.innerWidth < 768 ? 26 : 34,
                        height: window.innerWidth < 768 ? 26 : 34,
                        // m: '10px 10px 5px 5px',
                        opacity: 0.9,
                        bgcolor: 'rgb(40, 40, 40)',
                        boxShadow: '0px 2px 6px grey',
                        color: 'rgb(0, 174, 255)',
                        cursor: 'pointer',
                        transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                        '&:hover': {
                            bgcolor: 'rgb(50, 50, 50)',
                            transform: 'scale(1.1)',

                        },
                        // zoom: window.innerWidth < 768 ? 0.8 : 1
                    }}
                    onClick={() => handleOpenToggle(!isOpen)}
                >
                    <AssignmentIcon sx={{ fontSize: window.innerWidth < 768 ? 19 : 24, color: 'white' }} />
                    <Box sx={{ position: 'relative', display: 'inline-block' }}>


                        {/* Badge для not_completed - верхний правый угол */}
                        {accountingsCounts && accountingsCounts.not_completed > 0 && (
                            <Badge
                                badgeContent={accountingsCounts.not_completed}
                                color="error"
                                max={9999}
                                variant="standard"
                                sx={{
                                    position: 'absolute',
                                    top: window.innerWidth < 768 ? -14 : -16,
                                    right: window.innerWidth < 768 ? -2 : -4,
                                    '& .MuiBadge-badge': {
                                        color: 'white',
                                        backgroundColor: 'var(--color-red)',
                                        fontSize: window.innerWidth < 768 ? 9 : 12,
                                        padding: '3px',
                                        height: 'auto',
                                        width: 'auto',
                                    },
                                }}
                            />
                        )}

                        {/* Badge для half_completed - верхний левый угол */}
                        {accountingsCounts && accountingsCounts.half_completed > 0 && (

                            <Badge
                                badgeContent={accountingsCounts.half_completed}
                                color="warning"
                                max={999}
                                variant="standard"
                                sx={{
                                    position: 'absolute',
                                    top: 0,
                                    right: window.innerWidth < 768 ? -10 : -12,
                                    '& .MuiBadge-badge': {
                                        color: 'black',
                                        backgroundColor: 'var(--color-orange)',
                                        fontSize: window.innerWidth < 768 ? 9 : 12,
                                        padding: '2px',
                                        width: 'auto',
                                        height: 'auto',
                                    }
                                }}
                            />
                        )}

                        {/* Badge для ready - нижний правый угол */}
                        {accountingsCounts && accountingsCounts.ready > 0 && (
                            <Badge
                                badgeContent={accountingsCounts.ready}
                                color="secondary"
                                max={999}
                                variant="standard"
                                sx={{
                                    position: 'absolute',
                                    bottom: window.innerWidth < 768 ? -14 : -16,
                                    right: window.innerWidth < 768 ? -2 : -4,
                                    '& .MuiBadge-badge': {
                                        color: 'white',
                                        backgroundColor: 'var(--color-blue)',
                                        fontSize: window.innerWidth < 768 ? 9 : 12,
                                        padding: '2px',
                                        width: 'auto',
                                        height: 'auto',
                                    }
                                }}
                            />
                        )}
                    </Box>


                </Paper>
            </Tooltip>
        </Box>

        , document.getElementById("map-controls-left-top")
    )




};

export default AccountingSheetTableButton; 